// Red Team / Blue Team + neutral green for login
export const PulseColors = {
  // Light surfaces
  backgroundLight: "#FFFFFF", // page background
  secondaryLight: "#F5F7FA", // cards / inputs

  // Brand & intents
  primary: "#2563EB", // BLUE (defense/stability) — primary brand
  secondary: "#10B981", // GREEN (neutral/login) — secondary accent
  dark: "#0B1020", // text/icons on light

  // Dark surfaces
  backgroundDark: "#0F1115",
  textLight: "#E6E6E6", // text on dark
  textDark: "#0B1020", // text on light

  // Extras for semantic palette (kept here so all colors still come from one source)
  error: "#EF4444", // RED (attacks/incidents)
  warning: "#F59E0B", // Amber (prompt injection, risky)
  info: "#3B82F6", // Blue light (info states)
  dividerLight: "#E5E7EB",
  dividerDark: "#242A33",
};
